<pm-modal ShowModal="ShowModal" 
          (OnClosed)="Close(undefined)" 
          [Header]="Header"
          BodyHeightPx="160"
          BodyWidthPx="400">
    <div style="background-color: white; padding: 4px;display: flex; flex-direction:column; height: 100%;">
        <div  style="flex-grow: 1; display: flex; justify-content: center; align-items: center;">
            <pm-icon-question-circle style="padding: 10px 20px;" IconSize="4" IconClass="icon-blue"></pm-icon-question-circle>
            <div class="controls-header layout-flex-fill">{{Content}}</div>
        </div>
        <div style="display:flex;">
            <pm-button class="flex-align-right" style="padding-left: 5px;  margin-top:0px; margin-bottom:0px" (click)="Close(true)">OK</pm-button>
            <pm-button style="padding-left: 5px;  margin-top:0px; margin-bottom:0px" (click)="Close(false)">Cancel</pm-button>            
        </div>
    </div>
</pm-modal>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/services/dialog/confirm-dialog.html